import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
interface LogoProps {
  variant?: 'full' | 'wordmark' | 'mark';
  /** Shows the tagline beneath the wordmark, as in the printed identity lockup. */
  withTagline?: boolean;
  className?: string;
  markClassName?: string;
}
export function Logo({
  variant = 'full',
  withTagline = false,
  className = '',
  markClassName = ''
}: LogoProps) {
  const {
    brand
  } = useBrand();
  const isUpper = brand.wordmarkCase === 'upper';
  return <span className={`inline-flex items-center gap-2.5 ${className}`} data-id="element-27" data-mp="yy43npg24irt">
      {variant !== 'wordmark' && <Mark className={markClassName} data-id="element-28" data-mp="13x7a9eboqx1w" />}
      {variant !== 'mark' && <span className="flex flex-col" data-id="element-29" data-mp="14036my7vxdo8">
          <span className={`font-serif leading-none ${isUpper ? 'text-[0.95em] font-medium tracking-wordmark' : 'text-[1.3em] font-semibold tracking-tight'}`} data-id="element-30" data-mp="18x3bx6wwucea">
            {brand.wordmark}
          </span>
          {withTagline && <span className="mt-2 text-[0.4em] uppercase tracking-label text-current opacity-80" data-id="element-31" data-mp="1ww8o5jw70o40">
              {brand.tagline}
            </span>}
        </span>}
      <span className="sr-only" data-id="element-32" data-mp="1nw2ek93m88a4">{brand.name}</span>
    </span>;
}
export function Mark({
  className = ''
}: {
  className?: string;
}) {
  const {
    brand
  } = useBrand();
  if (brand.mark === 'leaf') {
    return <svg viewBox="0 0 32 32" aria-hidden="true" className={`h-[1.5em] w-[1.5em] shrink-0 ${className}`} fill="none" data-id="element-33" data-mp="1dzfyryq5c7ey">
        <path d="M5 27C5 15.954 13.954 7 25 7C25 18.046 16.046 27 5 27Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" data-id="element-34" data-mp="148la6npfgvqc" />
        <path d="M5 27L19 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-35" data-mp="105g9mqowr44c" />
      </svg>;
  }

  /**
   * Republic monogram: a geometric R whose leg reads as a folded ribbon crossing
   * back over the stem, taken from the printed identity.
   */
  return <svg viewBox="0 0 40 44" aria-hidden="true" className={`h-[1.55em] w-[1.41em] shrink-0 ${className}`} data-id="element-36" data-mp="gk694n7ky38g">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H21.5C28.4 0 34 4.92 34 11C34 16.16 29.96 20.5 24.5 21.6L40 44H28.6L14.2 23H8V44H0V0ZM8 7H21C23.76 7 26 8.79 26 11C26 13.21 23.76 15 21 15H8V7Z" fill="currentColor" data-id="element-37" data-mp="6nbewgicaozz" />
      <path d="M14.2 23L22.4 34.95L17.9 41.5L6.6 25.2L14.2 23Z" fill="currentColor" opacity="0.55" data-id="element-38" data-mp="zch5rzbn54y4" />
    </svg>;
}